import Button from "@/components/atom/Button";
import Divider from "@/components/atom/Divider";
import currency from "@/functions/currency";
import { ArrowDownSvg, ArrowUpSvg } from "@/public/svg";
import { useMemo, useState } from "react";

export default function TopMitra({ datas = [] }) {
  let isFiveBestAgen = datas?.length > 5;
  const [showAll, setShowAll] = useState(false);
  const isdatas = useMemo(() => {
    return showAll ? datas : datas.slice(0, isFiveBestAgen ? 5 : datas?.length);
  }, [showAll, datas?.length]);

  return (
    <div>
      <div
        className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8
      flex flex-col gap-3 xs:gap-6
      '>
        <div className='flex flex-col gap-2'>
          <p className='subheading-semiBold text-greyscaleGON-700'>Top Agen</p>
          <p className='p2-regular sm:p1-regular text-greyscaleGON-400'>
            Menampilkan{" "}
            {showAll ? datas?.length : isFiveBestAgen ? 5 : datas?.length} Agen
            terbaik
          </p>
        </div>
        <Divider />
        <div className='flex flex-col gap-3 xs:gap-6'>
          {isdatas?.map((item, index) => (
            <div
              key={index}
              className='flex justify-between items-center'>
              <div className='flex items-center gap-3'>
                <p className='p1-medium text-greyscaleGON-700'>{index + 1}</p>
                <p className='p1-medium text-greyscaleGON-700'>
                  {item?.name_store}
                </p>
              </div>
              <div className='flex items-center gap-3'>
                {/* {index == 0 || index > 2 ? (
                  <div className='bg-successGON-50 p-1 rounded-full'>
                    <ArrowUpSvg className='h-4 w-h-4 text-successGON-500' />
                  </div>
                ) : (
                  <div className='bg-errorGON-50 p-1 rounded-full'>
                    <ArrowDownSvg className='h-4 w-h-4 text-errorGON-500' />
                  </div>
                )} */}
                <p className='p1-medium text-greyscaleGON-400'>
                  {currency(item?.total_pembayaran ?? 0)}
                </p>
              </div>
            </div>
          ))}
          {isFiveBestAgen && (
            <div>
              <Button
                label={showAll ? "Top 5 Agen" : "Lihat Semua"}
                variants='outline'
                onClick={() => setShowAll(!showAll)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
